import GrayBlackRider from './images/GrayBlackRider.png';
import GrayWhiteRider from './images/GrayWhiteRider.png';
import mainBanner from './images/main-banner.png';
import community from './images/community.png';
import SellOnMX from './images/SellOnMX.png';
import mockProducts from './mock-products.json';

export {
  GrayBlackRider,
  GrayWhiteRider,
  mainBanner,
  community,
  SellOnMX,
  mockProducts,
};
